import styled from 'styled-components';

export const ChooseMmtWrapper = styled.div`
	background-color: ${(p) => p.colorTheme === 'dark' ? '#0B1A2F' : '#f5f5f5'};
	position: relative;
	& .chooseNext, & .choosePrev {
		top: 0px;
	}
`;

export const WhatweofferWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
	padding:92px 16px 87px;
	${down(breakpoints.md)} {
		padding: 50px 0 16px 16px ;
	}
`
);

export const SliderOuterWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
	margin-bottom: 130px;
		& .slick-slide{
		padding-right: 20px;
	}
	${down(breakpoints.md)} {
		margin-bottom: 32px;
	}
`
);

export const WhyChooseMmtWrap = styled.div(
	({ colorTheme, width, theme: { down, breakpoints } }) => `
	display:flex !important;
	align-items: center;
	text-align:center;
	justify-content: center;
	background: ${colorTheme === 'dark' ? '#fff' : 'linear-gradient(70.63deg, #723B63 8.69%, #672D56 89.24%)'};
	border-radius: 6px;
	padding: 0 10px;
	min-height: 146px;
	font-size: 24px;
	color: ${colorTheme === 'dark' ? '#000' : '#fff'};
	font-weight: 900;
	width: ${width ? width : 'auto'} !important;
	${down(breakpoints.md)} {
		font-size: 16px;
		min-height:83px;
	}
`
);

export const PortfolioList = styled.ul(
	({ theme: { down, breakpoints } }) => `
	display: flex;
	flex-wrap: wrap;
	li {
		margin-right: 16px;
		margin-bottom: 13px;
		background-color: white;
		color: #0091FF;
		border-radius: 4px;
		font-size: 18px;
		padding: 16px;
		font-weight: 700;
		&:hover {
			cursor: pointer;
		}
		${down(breakpoints.md)} {
			width:100%;
			text-align:center;
			font-size:14px;
		}
	}
`
);
